import {Injectable} from "@angular/core";
import {fromEvent, map, Observable, startWith} from "rxjs";

@Injectable({
  providedIn: 'root'
})
/**
 * @deprecated The MobileService should not be used for design changes. Use SCSS instead with media queries.
 *
 * @see https://trined.atlassian.net/browse/TRIK-2894
 */
export class MobileService {
  public isMobile(): Observable<boolean> {
    return fromEvent(window, 'resize')
      .pipe(
        startWith(window.innerWidth <= 768),
        map(() => window.innerWidth <= 768)
      );
  }

  public isTablet(): Observable<boolean> {
    return fromEvent(window, 'resize')
      .pipe(
        startWith(window.innerWidth < 1200 && window.innerWidth >= 768),
        map(() => window.innerWidth < 1200 && window.innerWidth >= 768)
      );
  }

  public isDesktop(): Observable<boolean> {
    return fromEvent(window, 'resize')
      .pipe(
        startWith(window.innerWidth >= 1200),
        map(() => window.innerWidth >= 1200)
      );
  }
}
